import React from 'react';
import {
  Button,
  Nav,
  Navbar as NavbarComponent,
  NavItem,
  Spinner,
} from 'reactstrap';
import { authContext } from '../../config/adal';
import { PractitionerContext } from '../../contexts/practitioner';
import { NewPatientButton } from '../Buttons';
import ProfileButton from '../Buttons/Profile';
import NavCrumbs from '../NavCrumbs';
import UserProvider from '../Providers/User';
import './index.css';

const Authenticated = () => (
  <>
    <Nav navbar>
      <NavCrumbs />
    </Nav>
    <Nav className="ml-auto" navbar>
      <NavItem className="mt-auto mb-auto mr-3">
        <NewPatientButton />
      </NavItem>
      <ProfileButton />
    </Nav>
  </>
);

type LoginProps = {
  loading: boolean;
};

const Login = ({ loading }: LoginProps) => (
  <Nav className="ml-auto">
    <Button disabled={loading} outline onClick={() => authContext.login()}>
      {(loading && <Spinner size="sm" />) || 'Log in'}
    </Button>
  </Nav>
);

const Navbar = () => {
  return (
    <UserProvider>
      <PractitionerContext.Consumer>
        {({ loading, practitioner }) => (
          <NavbarComponent sticky={'top'} expand color={'light'}>
            {!loading && practitioner ? (
              <Authenticated />
            ) : (
              <Login loading={!!loading} />
            )}
          </NavbarComponent>
        )}
      </PractitionerContext.Consumer>
    </UserProvider>
  );
};
export default Navbar;
